import { render } from "./AttivitaLista.vue?vue&type=template&id=70dddc2e&scoped=true"
import script from "./AttivitaLista.vue?vue&type=script&lang=js"
export * from "./AttivitaLista.vue?vue&type=script&lang=js"

import "./AttivitaLista.vue?vue&type=style&index=0&id=70dddc2e&scoped=true&lang=css"

import exportComponent from "D:\\documenti\\Lavoro\\Niemit\\com.niemit.cortebenedetto\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dddc2e"]])

export default __exports__